import React, { useEffect, useState } from "react";

import "../../../Assets/CSS/bulkorder.css";

import "../oms.css";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import Up from "../../../Assets/Images/OMS/up.svg";
import Down from "../../../Assets/Images/OMS/down.svg";
import { useFormik } from "formik";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import { Box, Button, Card } from "@mui/material";
import { Document, Page } from "react-pdf";
import { pdfjs } from "react-pdf";

import axios from "axios";
import Modal from "@mui/material/Modal";
import { ClipLoader } from "react-spinners";
import toast from "react-hot-toast";
import moment from "moment";
import UploadDocs from "../common/uploadDocs";
import ShowPDF from "../common/pdfViewer";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

function SupplierDetailsForm({
  setSelectedDataInventory,
  setSelectedDataSupplier,
  orderId,
  opSourcingDetails,
  getOMSData,
  omsData,
}) {
  const isPending =
    omsData?.only_bnps?.ayekart_lvl1_status !== "Approved" ||
    omsData?.only_bnps?.ayekart_lvl2_status !== "Approved";
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    maxHeight: "80%",
    bgcolor: "background.paper",
    //   border: "2px solid #000",
    boxShadow: 24,
    //   pt: 2,
    //   px: 4,
    //   pb: 3,
    p: 2,
  };

  const [supplierDetails, setSupplierDetails] = useState(false);
  const [modalOpenInventory, setModalOpenInventory] = useState(false);
  const [modalOpenSupplier, setModalOpenSupplier] = useState(false);
  const [inventoryData, setInventoryData] = useState([]);
  const [inventorySearch, setInventorySearch] = useState("");
  const [inventoryLoader, setInventoryLoader] = useState(false);
  const [supplierLoader, setSupplierLoader] = useState(false);
  const [supplierData, setSupplierData] = useState([]);
  const [supplierSearch, setSupplierSearch] = useState("");
  const [supplierMobile, setSupplierMobile] = useState("");
  const [selectedItemInventory, setSelectedItemInventory] = useState({});
  const [selectedItemSupplier, setSelectedItemSupplier] = useState({});
  const [rmDetails, setRmDetails] = useState([]);
  const [formDisable, setFormDisable] = useState(false);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const [supplierDoc, setSupplierDoc] = useState([]);
  const addObject = (newObject) => {
    setSupplierDoc([...supplierDoc, newObject]);
  };
  const handleAddObject = (newObject) => {
    addObject(newObject);
  };
  console.log(omsData, "Details");
  const handleClose = () => setOpen(false);

  function isEmptyObject(obj) {
    return Object.keys(obj).length === 0 && obj?.constructor === Object;
  }

  const handleModalCloseInventory = () => {
    setModalOpenInventory(false);
    setSelectedItemInventory({});
    setSelectedDataInventory({});
    formik.resetForm();
  };

  const handleModalCloseSupplier = () => {
    setModalOpenSupplier(false);
    setSelectedItemSupplier({});
    setSelectedDataSupplier({});
    formik.resetForm();
  };

  const handleModalOpenInventory = () => {
    setModalOpenInventory(true);
    setSelectedItemSupplier({});
    setSelectedDataSupplier({});
    formik.resetForm();
  };
  const handleModalOpenSupplier = () => {
    setModalOpenSupplier(true);
    setSelectedItemInventory({});
    setSelectedItemInventory({});
    formik.resetForm();
  };

  const [activeModal, setActiveModal] = useState(false);
  const [pdfUrl, setPdfUrl] = useState("");
  // ------------------------------------ View pdf files -----------------------------------------------
  const handleModalClose = () => {
    setPdfUrl("");
    setActiveModal(false);
  };

  const handleModalOpen = (url) => {
    setPdfUrl(url);
    setActiveModal(true);
  };

  const initialValues = {
    supplier_name: null,
    field_executive: null,
    po_date: null,
    po_number: null,
    address_line_1: null,
    address_line_2: null,
    city_state: null,
    pin_code: null,
    gst_number: null,
    pan: null,
    contact_no: null,
    bank_ac_no: null,
    branch: null,
    ifsc_code: null,
    total_amount: 0,
    quantity: null,
    uom: null,
    gst: null,
    supplier_firm_name: null,
    commodity_name: null,
    rate_in_qtl: null,
    supplier_invoice_number: null,
    unit_price: null,
    supplier_invoice_date: null,
    loaded_weight_in_qtl: null,
    total_invoice_value: null,
    cgst: 0,
    sgst: 0,
    igst: 0,
  };
  const validate = (values) => {
    const errors = {};

    // if (values.gst === null) {
    //   errors.gst = "GST Amount is Required!";
    // }

    if (values.unit_price === null) {
      errors.unit_price = "Unit Price is Required!";
    }

    if (values.quantity === null) {
      errors.quantity = "Quantity is Required!";
    }

    return errors;
  };

  const handleSubmit = async (values) => {
    const supplierPayload = {
      order_id: orderId,
      quantity: values.quantity ? values.quantity : null,
      sourcing_total_cp: values.total_amount ? values.total_amount : null,
      product_id: selectedItemSupplier?.product_id
        ? selectedItemSupplier?.product_id
        : null,
      user_id: selectedItemSupplier?.user_id
        ? selectedItemSupplier?.user_id
        : null,
      partner_name: values.supplier_name ? values.supplier_name : null,
      gst_no: values.gst_number ? values.gst_number : null,
      pan_no: values.pan ? values.pan : null,
      firm_name: values?.supplier_firm_name ? values?.supplier_firm_name : null,
      mobile_number: values.contact_no ? values.contact_no : null,
      gst_amount: values.gst ? values.gst : null,
      rm_name: values.field_executive ? values.field_executive : null,
      po_date: values.po_date ? values.po_date : null,
      po_number: values.po_number ? values.po_number : null,
      unit_price: values.unit_price || null,
      rate_in_qtl: values?.rate_in_qtl || null,
      commodity_name: values?.commodity_name || null,
      supplier_invoice_number: values?.supplier_invoice_number || null,
      supplier_invoice_date: values?.supplier_invoice_date || null,
      loaded_weight_in_qtl: values?.loaded_weight_in_qtl || null,
      total_invoice_value: validate?.total_invoice_value || null,
      Supplier_attachments: opSourcingDetails?.Supplier_attachments
        ? [...opSourcingDetails?.Supplier_attachments, ...supplierDoc]
        : [...supplierDoc],
    };

    const inventoryPayload = {
      order_id: orderId,
      quantity: values.quantity ? values.quantity : null,
      sourcing_total_cp: values.total_amount ? values.total_amount : null,
      product_id: selectedItemInventory?.product_id
        ? selectedItemInventory?.product_id
        : null,
      user_id: selectedItemInventory?.supplier_id
        ? selectedItemInventory?.supplier_id
        : null,
      partner_name: values.supplier_name ? values.supplier_name : null,
      gst_no: values.gst_number ? values.gst_number : null,
      pan_no: values.pan ? values.pan : null,
      firm_name: values?.supplier_firm_name ? values?.supplier_firm_name : null,
      mobile_number: values.contact_no ? values.contact_no : null,
      gst_amount: values.gst ? values.gst : null,
      rm_name: values.field_executive ? values.field_executive : null,
      po_date: values.po_date ? values.po_date : null,
      po_number: values.po_number ? values.po_number : null,
      unit_price: values.unit_price || null,
      Supplier_attachments: opSourcingDetails?.Supplier_attachments
        ? [...opSourcingDetails?.Supplier_attachments, ...supplierDoc]
        : [...supplierDoc],
      rate_in_qtl: values?.rate_in_qtl || null,
      commodity_name: values?.commodity_name || null,
      supplier_invoice_number: values?.supplier_invoice_number || null,
      supplier_invoice_date: values?.supplier_invoice_date || null,
      loaded_weight_in_qtl: values?.loaded_weight_in_qtl || null,
      total_invoice_value: validate?.total_invoice_value || null,
    };

    const supplierUrl = "/api/oms/sourcers";
    const inventoryUrl = `/api/oms/sourcers/${selectedItemInventory?.id}`;

    try {
      setLoading(true);
      const { data } = await axios.post(
        isEmptyObject(selectedItemInventory) ? supplierUrl : inventoryUrl,
        isEmptyObject(selectedItemInventory)
          ? supplierPayload
          : inventoryPayload
      );
      if (data.status) {
        formik.resetForm();
        setSelectedDataInventory({});
        setSelectedDataSupplier({});
        getOMSData();
        setLoading(false);
        toast.success(data.message);
      } else {
        setLoading(false);
        toast.error(data.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error.response ? error.response.message : "Error Occured");
    }
  };

  const formik = useFormik({
    initialValues: initialValues,
    validate,
    onSubmit: async (values) => {
      const supplierPayload = {
        order_id: orderId,
        po_date: values.po_date ? values.po_date : null,
        po_number: values.po_number ? values.po_number : null,
      };

      const url = `/api/oms/sourcers/${opSourcingDetails?.id}`;

      try {
        setLoading(true);
        const { data } = await axios.patch(url, supplierPayload);
        if (data.status) {
          getOMSData();
          setLoading(false);
          toast.success(data.message);
        } else {
          setLoading(false);
          toast.error(data.message);
        }
      } catch (error) {
        console.log(error);
        toast.error(error.response ? error.response.message : "Error Occured");
      }
    },
  });

  const getRMDetails = async () => {
    const url = `/api/oms/relationship_managers`;

    try {
      const { data } = await axios.get(url);
      if (data.status) {
        setRmDetails(data?.rms);
      } else {
        setRmDetails([]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getInventoryData = async (productSearch) => {
    const url = `/api/oms/products?limit=1000&product_name=${productSearch}`;

    try {
      setInventoryLoader(true);
      const { data } = await axios.get(url);
      if (data.status) {
        setInventoryData(data?.products?.rows);
      } else {
        setInventoryData([]);
      }
      setInventoryLoader(false);
    } catch (error) {
      setInventoryLoader(false);
      console.log(error);
    }
  };

  const getExistingSupplier = async (supplierSearch, supplierMobile) => {
    const url = `/api/sourcers?limit=1000&shop_name=${supplierSearch}&supplier_mobile=${supplierMobile}`;

    try {
      setSupplierLoader(true);
      const { data } = await axios.get(url);
      if (data.status) {
        setSupplierData(data?.products?.rows);
      } else {
        setSupplierData([]);
      }
      setSupplierLoader(false);
    } catch (error) {
      setSupplierLoader(false);
      console.log(error);
    }
  };

  const handleSelectFromInventory = () => {
    setSelectedDataInventory(selectedItemInventory);
    setSelectedDataSupplier({});
    setModalOpenInventory(false);
  };

  const handleSelectFromSupplier = () => {
    setSelectedDataSupplier(selectedItemSupplier);
    setSelectedDataInventory({});
    setModalOpenSupplier(false);
  };

  const calculateTotalAmount = () => {
    const quantity = formik.values.quantity || 0;
    const gstAmount = formik.values.gst || 0;
    const unitPrice = formik.values.unit_price || 0;
    const totalAmount = unitPrice * quantity + gstAmount;
    formik.setFieldValue("total_amount", totalAmount);
  };

  const calculateTaxes = () => {
    const gstAmount = formik.values.gst;
    const rmGst =
      opSourcingDetails?.[0]?.supplier?.relationship_manager?.gst_number;
    const buyerGst = omsData?.buyer_gst_no;
    let cgst_amt = 0;
    let igst_amt = 0;
    let sgst_amt = 0;
    const firstTwoCharsString1 = rmGst?.substring(0, 2);
    const firstTwoCharsString2 = buyerGst?.substring(0, 2);

    const areFirstTwoCharsSame = firstTwoCharsString1 === firstTwoCharsString2;

    if (areFirstTwoCharsSame == false) {
      igst_amt = gstAmount;
      cgst_amt = 0;
      sgst_amt = 0;
    } else {
      const half_gst = (parseFloat(gstAmount) / 2).toFixed(2);
      igst_amt = 0;
      sgst_amt = half_gst;
      cgst_amt = half_gst;
    }

    formik.setFieldValue("igst", igst_amt);
    formik.setFieldValue("sgst", sgst_amt);
    formik.setFieldValue("cgst", cgst_amt);
  };

  useEffect(() => {
    getRMDetails();
  }, []);

  useEffect(() => {
    calculateTotalAmount();
    calculateTaxes();
  }, [formik.values.quantity, formik.values.gst, formik.values.unit_price]);

  useEffect(() => {
    let token;
    if (inventorySearch) {
      clearTimeout(token);
      token = setTimeout(() => {
        if (modalOpenInventory) {
          getInventoryData(inventorySearch);
        }
      }, 1000);
    } else {
      if (modalOpenInventory) {
        getInventoryData(inventorySearch);
      }
    }
    return () => clearTimeout(token);
  }, [inventorySearch, modalOpenInventory]);

  useEffect(() => {
    let token;
    if (supplierSearch || supplierMobile) {
      clearTimeout(token);
      token = setTimeout(() => {
        if (modalOpenSupplier) {
          getExistingSupplier(supplierSearch, supplierMobile);
        }
      }, 1000);
    } else {
      if (modalOpenSupplier) {
        getExistingSupplier(supplierSearch, supplierMobile);
      }
    }
    return () => clearTimeout(token);
  }, [supplierSearch, modalOpenSupplier, supplierMobile]);

  useEffect(() => {
    const isInventorySelected = Object.keys(selectedItemInventory).length !== 0;
    const isSupplierSelected = Object.keys(selectedItemSupplier).length !== 0;
    const hasOpSourcingDetails = !isEmptyObject(opSourcingDetails);

    if (isInventorySelected) {
      setFormDisable(false);
      formik.setValues({
        ...formik.values,
        supplier_name: selectedItemInventory?.supplier?.first_name
          ? `${selectedItemInventory?.supplier?.first_name} ${selectedItemInventory?.supplier?.last_name}`
          : "",
        supplier_firm_name: selectedItemInventory?.supplier?.shop?.name
          ? selectedItemInventory?.supplier?.shop?.name
          : "",
        pin_code: selectedItemInventory?.supplier?.shop?.pin_code
          ? selectedItemInventory?.supplier?.shop?.pin_code
          : "",
        address_line_1: selectedItemInventory?.supplier?.shop?.address1
          ? selectedItemInventory?.supplier?.shop?.address1
          : "",
        address_line_2: selectedItemInventory?.supplier?.shop?.address2
          ? selectedItemInventory?.supplier?.shop?.address2
          : "",
        gst_number: selectedItemInventory?.supplier?.user_kyc?.gst_number
          ? selectedItemInventory?.supplier?.user_kyc?.gst_number
          : "",
        pan: selectedItemInventory?.supplier?.user_kyc?.pan_card
          ? selectedItemInventory?.supplier?.user_kyc?.pan_card
          : "",
        contact_no: selectedItemInventory?.supplier?.mobile_number
          ? selectedItemInventory?.supplier?.mobile_number
          : "",
        bank_ac_no: selectedItemInventory?.supplier?.user_kyc?.bank_account_no
          ? selectedItemInventory?.supplier?.user_kyc?.bank_account_no
          : "",
        branch: selectedItemInventory?.supplier?.user_kyc?.bank_branch_name
          ? selectedItemInventory?.supplier?.user_kyc?.bank_branch_name
          : "",
        ifsc_code: selectedItemInventory?.supplier?.user_kyc?.bank_ifsc_code
          ? selectedItemInventory?.supplier?.user_kyc?.bank_ifsc_code
          : "",
        city_state: selectedItemInventory?.supplier?.shop?.city
          ? `${selectedItemInventory?.supplier?.shop?.city}/${selectedItemInventory?.supplier?.shop?.state}`
          : "",
        // rate_in_qtl:selectedItemInventory?.,
      });
    } else if (isSupplierSelected) {
      setFormDisable(false);
      formik.setValues({
        ...formik.values,
        supplier_name: selectedItemSupplier?.supplier?.first_name
          ? `${selectedItemSupplier?.supplier?.first_name} ${selectedItemSupplier?.supplier?.last_name}`
          : "",
        pin_code: selectedItemSupplier?.supplier?.shop?.pin_code
          ? selectedItemSupplier?.supplier?.shop?.pin_code
          : "",
        address_line_1: selectedItemSupplier?.supplier?.shop?.address1
          ? selectedItemSupplier?.supplier?.shop?.address1
          : "",
        address_line_2: selectedItemSupplier?.supplier?.shop?.address2
          ? selectedItemSupplier?.supplier?.shop?.address2
          : "",
        gst_number: selectedItemSupplier?.supplier?.user_kyc?.gst_number
          ? selectedItemSupplier?.supplier?.user_kyc?.gst_number
          : "",
        pan: selectedItemSupplier?.supplier?.user_kyc?.pan_card
          ? selectedItemSupplier?.supplier?.user_kyc?.pan_card
          : "",
        contact_no: selectedItemSupplier?.supplier?.mobile_number
          ? selectedItemSupplier?.supplier?.mobile_number
          : "",
        bank_ac_no: selectedItemSupplier?.supplier?.user_kyc?.bank_account_no
          ? selectedItemSupplier?.supplier?.user_kyc?.bank_account_no
          : "NA",
        branch: selectedItemSupplier?.supplier?.user_kyc?.bank_branch_name
          ? selectedItemSupplier?.supplier?.user_kyc?.bank_branch_name
          : "NA",
        ifsc_code: selectedItemSupplier?.supplier?.user_kyc?.bank_ifsc_code
          ? selectedItemSupplier?.supplier?.user_kyc?.bank_ifsc_code
          : "",
        supplier_firm_name: selectedItemSupplier?.supplier?.shop?.name
          ? selectedItemSupplier?.supplier?.shop?.name
          : "",
        po_number: selectedItemSupplier?.po_number
          ? selectedItemSupplier?.po_number
          : "",
      });
    } else if (hasOpSourcingDetails) {
      setFormDisable(true);
      formik.setValues({
        ...formik.values,
        supplier_name: opSourcingDetails?.partner_name
          ? opSourcingDetails?.partner_name
          : "",
        pin_code: opSourcingDetails?.supplier?.shop?.pin_code
          ? opSourcingDetails?.supplier?.shop?.pin_code
          : "",
        address_line_1: opSourcingDetails?.supplier?.shop?.address1
          ? opSourcingDetails?.supplier?.shop?.address1
          : "",
        address_line_2: opSourcingDetails?.supplier?.shop?.address2
          ? opSourcingDetails?.supplier?.shop?.address2
          : "",
        gst_number: opSourcingDetails?.gst_no ? opSourcingDetails?.gst_no : "",
        pan: opSourcingDetails?.supplier?.user_kyc?.pan_card
          ? opSourcingDetails?.supplier?.user_kyc?.pan_card
          : "",
        contact_no: opSourcingDetails?.supplier?.mobile_number
          ? opSourcingDetails?.supplier?.mobile_number
          : "",
        bank_ac_no: opSourcingDetails?.supplier?.user_kyc?.bank_account_no
          ? opSourcingDetails?.supplier?.user_kyc?.bank_account_no
          : "",
        branch: opSourcingDetails?.supplier?.user_kyc?.bank_branch_name
          ? opSourcingDetails?.supplier?.user_kyc?.bank_branch_name
          : "",
        ifsc_code: opSourcingDetails?.supplier?.user_kyc?.bank_ifsc_code
          ? opSourcingDetails?.supplier?.user_kyc?.bank_ifsc_code
          : "",
        supplier_firm_name: opSourcingDetails?.supplier?.shop?.name
          ? opSourcingDetails?.supplier?.shop?.name
          : "",
        po_number: opSourcingDetails?.po_number
          ? opSourcingDetails?.po_number
          : "",
        field_executive: opSourcingDetails?.rm_name || null,
        po_date: opSourcingDetails?.po_date
          ? moment(opSourcingDetails?.po_date).format("YYYY-MM-DD")
          : null,
        quantity: opSourcingDetails?.quantity || null,
        uom: opSourcingDetails?.measurement_unit || null,
        gst: opSourcingDetails?.gst_amount || null,
        total_amount: opSourcingDetails?.sourcing_total_cp || null,
        city_state: opSourcingDetails?.supplier?.shop?.city
          ? `${opSourcingDetails?.supplier?.shop?.city}/${opSourcingDetails?.supplier?.shop?.state}`
          : null,
        unit_price: opSourcingDetails?.rate || 0,
        rate_in_qtl: opSourcingDetails?.rate_in_qtl || 0,
        commodity_name: opSourcingDetails?.commodity_name || null,
        supplier_invoice_number:
          opSourcingDetails?.supplier_invoice_number || null,
        supplier_invoice_date: opSourcingDetails?.supplier_invoice_date || null,
        loaded_weight_in_qtl: opSourcingDetails?.loaded_weight_in_qtl || null,
        total_invoice_value: opSourcingDetails?.total_invoice_value || null,
      });
    } else {
      setFormDisable(false);
      formik.resetForm();
    }
  }, [
    selectedItemInventory,
    formik.setValues,
    selectedItemSupplier,
    opSourcingDetails,
  ]);

  // ------------------ view doc ----------------------------------------------------------

  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [clientId, setClientId] = useState();
  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  function changePage(offset) {
    setPageNumber((prevPageNumber) => prevPageNumber + offset);
  }

  function previousPage() {
    changePage(-1);
  }

  function nextPage() {
    changePage(1);
  }
  return (
    <>
      <Modal
        className="p-0"
        open={modalOpenInventory}
        onClose={handleModalCloseInventory}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box sx={{ ...style }}>
          <h5 id="child-modal-title">Select From Inventory</h5>
          <hr className="font-bold text-neutral-500 bg-gray-900 " />
          <div className="">
            <div className="row mt-3">
              <div className="mb-3">
                <label
                  for="inventorySearch"
                  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  Search Product Inventory
                </label>
                <input
                  type="text"
                  name="inventorySearch"
                  id="inventorySearch"
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="Search Product ..."
                  onChange={(e) => setInventorySearch(e.target.value)}
                />
              </div>
            </div>
            {inventoryLoader ? (
              <div className="text-center">
                <ClipLoader />
              </div>
            ) : (
              <ul className="overflow-y-scroll max-h-72 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white">
                {inventoryData?.length === 0 ? (
                  <p className="text-center py-2">No Data Found</p>
                ) : (
                  inventoryData?.map((each, index) => (
                    <li
                      key={index}
                      className="w-full border-b border-gray-200 rounded-t-lg dark:border-gray-600"
                    >
                      <div className="flex items-center ps-3">
                        <input
                          id={`inventorySupplier${index}`}
                          type="radio"
                          value=""
                          name="inventorySupplier"
                          className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
                          onChange={(e) => setSelectedItemInventory(each)}
                        />
                        <label
                          htmlFor={`inventorySupplier${index}`}
                          className="w-full py-2 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                        >
                          <p>
                            <b>Product Name: </b>
                            {each?.product?.product_name
                              ? each?.product?.product_name
                              : "NA"}
                          </p>
                          <p>
                            <b>Location: </b>
                            {each?.warehouse_location
                              ? each?.warehouse_location
                              : "NA"}
                          </p>
                          <p>
                            <b>Supplier: </b>
                            {each?.supplier?.shop?.name
                              ? each?.supplier?.shop?.name
                              : "NA"}
                          </p>
                          <p>
                            <b>Quantity: </b>
                            {each?.available_quantity
                              ? each?.available_quantity
                              : "NA"}
                          </p>
                        </label>
                      </div>
                    </li>
                  ))
                )}
              </ul>
            )}
          </div>
          <div className="text-center">
            <button
              className="mr-3 bg-green-700 rounded text-white p-2"
              onClick={handleSelectFromInventory}
            >
              Submit
            </button>
            <button
              className="bg-red-600 rounded text-white p-2"
              onClick={handleModalCloseInventory}
            >
              Cancel
            </button>
          </div>
        </Box>
      </Modal>
      <Modal
        className="p-0"
        open={modalOpenSupplier}
        onClose={handleModalCloseSupplier}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box sx={{ ...style }}>
          <h5 id="child-modal-title">Select Supplier</h5>
          <hr className="font-bold text-neutral-500 bg-gray-900 " />
          <div className="">
            <div className="grid grid-cols-2 gap-3">
              <div className="mb-3 ">
                <label
                  for="supplierSearch"
                  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  Search Supplier
                </label>
                <input
                  type="text"
                  name="supplierSearch"
                  id="supplierSearch"
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="Search Supplier Name ..."
                  onChange={(e) => setSupplierSearch(e.target.value)}
                />
              </div>
              <div className="mb-3">
                <label
                  for="supplierMobile"
                  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  Search Supplier Mobile
                </label>
                <input
                  type="text"
                  name="supplierMobile"
                  id="supplierMobile"
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="Search Supplier Mobile ..."
                  onChange={(e) => setSupplierMobile(e.target.value)}
                />
              </div>
            </div>
            {supplierLoader ? (
              <div className="text-center">
                <ClipLoader />
              </div>
            ) : (
              <ul className="overflow-y-scroll max-h-72 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:text-white">
                {supplierData?.length === 0 ? (
                  <p className="text-center py-2">No Data Found</p>
                ) : (
                  supplierData?.map((each, index) => (
                    <li
                      key={index}
                      className="w-full border-b border-gray-200 rounded-t-lg dark:border-gray-600"
                    >
                      <div className="flex items-center ps-3">
                        <input
                          id={`selectedSupplier${index}`}
                          type="radio"
                          value=""
                          name="selectedSupplier"
                          className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-700 dark:focus:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
                          onChange={(e) => setSelectedItemSupplier(each)}
                        />
                        <label
                          htmlFor={`selectedSupplier${index}`}
                          className="w-full py-2 ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                        >
                          <p>
                            <b>Supplier Name: </b>
                            {each?.supplier?.shop?.name}
                          </p>
                          <p>
                            <b>Phone Number: </b>
                            {each?.supplier?.mobile_number
                              ? each?.supplier?.mobile_number
                              : "NA"}
                          </p>
                        </label>
                      </div>
                    </li>
                  ))
                )}
              </ul>
            )}
          </div>
          <div className="text-center">
            <button
              className="mr-3 bg-green-700 rounded text-white p-2"
              onClick={handleSelectFromSupplier}
            >
              Submit
            </button>
            <button
              className="bg-red-600 rounded text-white p-2"
              onClick={handleModalCloseSupplier}
            >
              Cancel
            </button>
          </div>
        </Box>
      </Modal>

      <div className="shadow-lg m-2 p-2 pb-2 rounded-lg">
        <div className="flex flex-col sm:flex-row justify-between">
          <div className="font-medium text-cyan-950 text-md flex gap-2">
            {/* <img src={Profile} alt="" /> */}
            <AccountBoxIcon className="mt-1" />
            <div className="mt-1">Supplier Details</div>
            {isEmptyObject(opSourcingDetails) && !isPending && (
              <>
                {" "}
                {/* <Button
                  className="ms-3"
                  variant="contained"
                  size="small"
                  onClick={handleModalOpenSupplier}
                  sx={{ backgroundColor: "#05124C" }}
                >
                  + Add Existing Supplier
                </Button> */}
                <Button
                  className="ms-3"
                  variant="contained"
                  size="small"
                  onClick={handleModalOpenInventory}
                  sx={{ backgroundColor: "#05124C" }}
                >
                  + Add From Inventory
                </Button>
              </>
            )}
          </div>
          <div>
            {supplierDetails ? (
              <div className="font-medium text-cyan-950 text-lg mt-3">
                <img
                  src={Up}
                  alt=""
                  role="button"
                  onClick={() => setSupplierDetails(!supplierDetails)}
                />
              </div>
            ) : (
              <div className="font-medium text-cyan-950 text-lg mt-3">
                <img
                  src={Down}
                  alt=""
                  role="button"
                  onClick={() => setSupplierDetails(!supplierDetails)}
                />
              </div>
            )}
          </div>
        </div>
        <div>
          <hr className="font-bold text-neutral-500 bg-gray-900 h-0.5" />
        </div>
        <div>
          {supplierDetails ? (
            <></>
          ) : (
            <div>
              <form onSubmit={formik.handleSubmit}>
                {/* {isEmptyObject(opSourcingDetails) && (
                  <div className="row mt-3 ">
                    <div className="col col-md-6 col-lg-6 col-sm-6">
                      <Button
                        variant="contained"
                        onClick={handleModalOpenSupplier}
                      >
                        + Add Existing Supplier
                      </Button>
                    </div>
                    <div className="col col-md-6 col-lg-6 col-sm-6">
                      <Button
                        variant="contained"
                        onClick={handleModalOpenInventory}
                      >
                        + Add From Inventory
                      </Button>
                    </div>
                  </div>
                )} */}
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 ">
                  <div>
                    <label
                      for="supplier_name"
                      className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                    >
                      Supplier Name
                    </label>
                    <input
                      type="text"
                      id="supplier_name"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="supplier_name"
                      value={formik.values.supplier_name}
                      disabled
                    />
                    {formik.errors.supplier_name ? (
                      <div className="text-red-600 text-sm">
                        {formik.errors.supplier_name}
                      </div>
                    ) : null}
                  </div>
                  <div>
                    <label
                      for="supplier_firm_name"
                      className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                    >
                      Supplier Firm Name
                    </label>
                    <input
                      type="text"
                      id="supplier_firm_name"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="supplier_firm_name"
                      value={formik.values.supplier_firm_name}
                      disabled
                    />
                    {formik.errors.supplier_firm_name ? (
                      <div className="text-red-600 text-sm">
                        {formik.errors.supplier_firm_name}
                      </div>
                    ) : null}
                  </div>

                  <div>
                    <label
                      for="po_date"
                      className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                    >
                      Supplier PO date
                    </label>
                    <input
                      type="date"
                      id="po_date"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="po_date"
                      onChange={formik.handleChange}
                      value={formik.values.po_date}
                      disabled={isPending}
                    />
                    {formik.errors.po_date ? (
                      <div className="text-red-600 text-sm">
                        {formik.errors.po_date}
                      </div>
                    ) : null}
                  </div>
                  <div>
                    <label
                      for="po_number"
                      className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                    >
                      Supplier PO name
                    </label>
                    <input
                      type="text"
                      id="po_number"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="po_number"
                      placeholder="Enter PO name"
                      onChange={formik.handleChange}
                      value={formik.values.po_number}
                      disabled={isPending}
                    />
                    {formik.errors.po_number ? (
                      <div className="text-red-600 text-sm">
                        {formik.errors.po_number}
                      </div>
                    ) : null}
                  </div>
                  <div>
                    <label className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1">
                      Field Executive
                    </label>
                    <select
                      value={formik.values.field_executive}
                      onChange={formik.handleChange}
                      disabled
                      name="field_executive"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    >
                      <option value="Select Expense">Select Option</option>
                      {rmDetails.map((each, index) => (
                        <option value={each?.rm_name} key={index}>
                          {each?.rm_name}
                        </option>
                      ))}
                    </select>
                    {formik.errors.field_executive ? (
                      <div className="text-red-600 text-sm">
                        {formik?.errors?.field_executive}
                      </div>
                    ) : null}
                  </div>
                  <div>
                    <label
                      for="quantity"
                      className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                    >
                      Quantity
                    </label>
                    <input
                      type="number" onWheel={(e) => e.target.blur()}
                      id="quantity"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="quantity"
                      placeholder="Enter Quantity"
                      onChange={formik.handleChange}
                      value={formik.values.quantity}
                      disabled
                    />
                    {formik.errors.quantity && formik.touched.quantity ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.quantity}
                      </div>
                    ) : null}
                  </div>
                  <div>
                    <label
                      for="uom"
                      className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                    >
                      UOM
                    </label>
                    <input
                      type="number" onWheel={(e) => e.target.blur()}
                      id="uom"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="uom"
                      placeholder="Unit of measurement"
                      onChange={formik.handleChange}
                      value={formik.values.uom}
                      disabled
                    />
                    {formik.errors.uom && formik.touched.uom ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.uom}
                      </div>
                    ) : null}
                  </div>
                  <div>
                    <label
                      for="gst"
                      className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                    >
                      GST(Amount)
                    </label>
                    <input
                      type="number" onWheel={(e) => e.target.blur()}
                      id="gst"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="gst"
                      placeholder="Enter GST (Rs)"
                      onChange={formik.handleChange}
                      value={formik.values.gst || "NA"}
                      disabled
                    />
                  </div>
                  <div>
                    <label
                      for="cgst"
                      className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                    >
                      CGST
                    </label>
                    <input
                      type="number" onWheel={(e) => e.target.blur()}
                      id="cgst"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="cgst"
                      onChange={formik.handleChange}
                      value={formik.values.cgst || "NA"}
                      disabled
                    />
                  </div>
                  <div>
                    <label
                      for="sgst"
                      className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                    >
                      SGST
                    </label>
                    <input
                      type="number" onWheel={(e) => e.target.blur()}
                      id="sgst"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="sgst"
                      value={formik.values.sgst}
                      disabled
                    />
                  </div>
                  <div>
                    <label
                      for="igst"
                      className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                    >
                      IGST
                    </label>
                    <input
                      type="number" onWheel={(e) => e.target.blur()}
                      id="igst"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="igst"
                      value={formik.values.igst}
                      disabled
                    />
                  </div>
                  <div>
                    <label
                      for="unit_price"
                      className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                    >
                      Unit Price (Rs)
                    </label>
                    <input
                      type="number" onWheel={(e) => e.target.blur()}
                      id="unit_price"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="unit_price"
                      placeholder="Enter Unit Price (Rs)"
                      onChange={formik.handleChange}
                      value={formik.values.unit_price || "NA"}
                      disabled
                    />
                    {formik.errors.unit_price && formik.touched.unit_price ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.unit_price}
                      </div>
                    ) : null}
                  </div>
                  <div>
                    <label
                      for="total_amount"
                      className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                    >
                      Total Amount(Total CP)
                    </label>
                    <input
                      type="number" onWheel={(e) => e.target.blur()}
                      id="total_amount"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="total_amount"
                      value={formik.values.total_amount || "NA"}
                      disabled
                    />
                    {formik.errors.total_amount ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.total_amount}
                      </div>
                    ) : null}
                  </div>
                  <div>
                    <label
                      for="address_line_1"
                      className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                    >
                      Address Line 1
                    </label>
                    <input
                      type="text"
                      id="address_line_1"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="address_line_1"
                      value={formik.values.address_line_1 || "NA"}
                      disabled
                    />
                    {formik.errors.address_line_1 ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.address_line_1}
                      </div>
                    ) : null}
                  </div>
                  <div>
                    <label
                      for="address_line_2"
                      className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                    >
                      Address Line 2
                    </label>
                    <input
                      type="text"
                      id="address_line_2"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="address_line_2"
                      value={formik.values.address_line_2 || "NA"}
                      disabled
                    />
                    {formik.errors.address_line_2 ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.address_line_2}
                      </div>
                    ) : null}
                  </div>
                  <div>
                    <label
                      for="city_state"
                      className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                    >
                      City/State
                    </label>
                    <input
                      type="text"
                      id="city_state"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="city_state"
                      value={formik.values.city_state || "NA"}
                      disabled
                    />
                    {formik.errors.city_state ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.city_state}
                      </div>
                    ) : null}
                  </div>
                  <div className="mb-3">
                    <label
                      for="pin_code"
                      className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                    >
                      Pin Code
                    </label>
                    <input
                      type="text"
                      id="pin_code"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="pin_code"
                      value={formik.values.pin_code || "NA"}
                      disabled
                    />
                    {formik.errors.pin_code ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.pin_code}
                      </div>
                    ) : null}
                  </div>
                  <div>
                    <label
                      for="gst_number"
                      className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                    >
                      GST Number
                    </label>
                    <input
                      type="text"
                      id="gst_number"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="gst_number"
                      value={formik.values.gst_number || "NA"}
                      disabled
                    />
                    {formik.errors.gst_number ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.gst_number}
                      </div>
                    ) : null}
                  </div>
                  <div>
                    <label
                      for="pan"
                      className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                    >
                      PAN
                    </label>
                    <input
                      type="text"
                      id="pan"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="pan"
                      value={formik.values.pan || null}
                      disabled
                    />
                    {formik.errors.pan ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.pan}
                      </div>
                    ) : null}
                  </div>
                  <div>
                    <label
                      for="contact_no"
                      className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                    >
                      Contact No
                    </label>
                    <input
                      type="text"
                      id="contact_no"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="contact_no"
                      value={formik.values.contact_no || "NA"}
                      disabled
                    />
                    {formik.errors.contact_no ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.contact_no}
                      </div>
                    ) : null}
                  </div>
                  <div>
                    <label
                      for="bank_ac_no"
                      className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                    >
                      Bank Ac No
                    </label>
                    <input
                      type="text"
                      id="bank_ac_no"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="bank_ac_no"
                      value={formik.values.bank_ac_no || "NA"}
                      disabled
                    />
                    {formik.errors.bank_ac_no ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.bank_ac_no}
                      </div>
                    ) : null}
                  </div>
                  <div>
                    <label
                      for="branch"
                      className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                    >
                      Branch
                    </label>
                    <input
                      type="text"
                      id="branch"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="branch"
                      value={formik.values.branch || "NA"}
                      disabled
                    />
                    {formik.errors.branch ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.branch}
                      </div>
                    ) : null}
                  </div>
                  <div>
                    <label
                      for="ifsc_code"
                      className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                    >
                      IFSC Code
                    </label>
                    <input
                      type="text"
                      id="ifsc_code"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="ifsc_code"
                      value={formik.values.ifsc_code || "NA"}
                      disabled
                    />
                    {formik.errors.ifsc_code ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.ifsc_code}
                      </div>
                    ) : null}
                  </div>
                  {/* New fields */}
                  <div>
                    <label
                      for="Commodity"
                      className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                    >
                      Commodity
                    </label>
                    <input
                      type="text"
                      id="commodity"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="commodity"
                      value={formik.values.commodity_name || "NA"}
                      disabled
                    />
                    {formik.errors.commodity_name ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.commodity_name}
                      </div>
                    ) : null}
                  </div>
                  <div>
                    <label
                      for="Commodity"
                      className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                    >
                      Supplier Invoice Number
                    </label>
                    <input
                      type="text"
                      id="supplier_invoice_number"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="supplier_invoice_number"
                      value={formik.values.supplier_invoice_number || "NA"}
                      // onChange={formik.handleChange}
                      disabled
                    />
                    {formik.errors.supplier_invoice_number ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.supplier_invoice_number}
                      </div>
                    ) : null}
                  </div>
                  <div>
                    <label
                      for="supplier_invoice_date"
                      className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                    >
                      Supplier Invoice Date
                    </label>

                    <input
                      type="date"
                      id="supplier_invoice_date"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="supplier_invoice_date"
                      value={formik.values.supplier_invoice_date || "NA"}
                      onChange={formik.handleChange}
                      disabled
                    />
                    {formik.errors.supplier_invoice_date ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.supplier_invoice_date}
                      </div>
                    ) : null}
                  </div>
                  <div>
                    <label
                      for="loaded_weight_in_qtl"
                      className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                    >
                      Loaded Weight in QTL
                    </label>
                    <input
                      type="number" onWheel={(e) => e.target.blur()}
                      id="loaded_weight_in_qtl"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="loaded_weight_in_qtl"
                      onChange={formik.handleChange}
                      value={formik.values?.loaded_weight_in_qtl || 0}
                      disabled
                    />
                    {formik.errors.loaded_weight_in_qtl ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.loaded_weight_in_qtl}
                      </div>
                    ) : null}
                  </div>
                  <div>
                    <label
                      for="rate_in_qtl"
                      className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                    >
                      Rate per Qtl
                    </label>
                    <input
                      type="number" onWheel={(e) => e.target.blur()}
                      id="rate_in_qtl"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="rate_in_qtl"
                      value={formik.values.rate_in_qtl || 0}
                      onChange={formik.handleChange}
                      disabled
                    />

                    {formik.errors.rate_in_qtl ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.rate_in_qtl}
                      </div>
                    ) : null}
                  </div>
                  <div>
                    <label
                      for="total_invoice_value"
                      className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                    >
                      Total invoice Value
                    </label>
                    <input
                      type="number" onWheel={(e) => e.target.blur()}
                      id="total_invoice_value"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="total_invoice_value"
                      value={formik.values.total_invoice_value || 0}
                      onChange={formik.handleChange}
                      disabled
                    />
                    {formik.errors.total_invoice_value ? (
                      <div className="text-red-600 text-sm flex justify-start ms-1">
                        {formik.errors.total_invoice_value}
                      </div>
                    ) : null}
                  </div>
                </div>
                {opSourcingDetails?.Supplier_attachments?.length > 0 ? (
                  <div className="flex justify-start mt-2">
                    {" "}
                    <h4 className="text-blue-900">Uploaded Documents</h4>
                  </div>
                ) : (
                  ""
                )}
                <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 mt-2">
                  {supplierDoc?.length > 0
                    ? supplierDoc?.map((item, index) => {
                        {
                          console.log(item);
                        }
                        return (
                          <>
                            <Card
                              sx={{
                                width: ["100%", "100%", "90%", "80%"],
                                bgcolor: "background.paper",
                                boxShadow: 24,
                                borderRadius: 2,
                                maxHeight: 300,
                                overflow: "auto",
                                backgroundColor: "#FEFEFE",
                              }}
                            >
                              <div className="flex justify-between m-2 mb-2">
                                <h5 className="text-center mt-2">
                                  {" "}
                                  {item?.type} Document
                                </h5>
                                <div className="flex justify-center">
                                  <h5 className="flex justify-between  text-teal-700 mt-2 ">
                                    <Button>
                                      <FileDownloadIcon
                                        icon="subway:download-1"
                                        width="24"
                                        height="24"
                                        className="ms-3"
                                        role="button"
                                      />
                                      <a
                                        style={{
                                          textDecoration: "none",
                                          color: "inherit",
                                        }}
                                        href={item?.url}
                                      >
                                        Download
                                      </a>
                                    </Button>
                                  </h5>
                                </div>
                              </div>

                              <div className=" flex justify-center border-2 mt-4 pb-5 border-b-teal-900  p-3">
                                {item?.url?.includes(".pdf") ? (
                                  <Document
                                    maxHeight={200}
                                    file={item?.url}
                                    onLoadSuccess={onDocumentLoadSuccess}
                                    onLoadError={(error) =>
                                      console.error(
                                        "Error while loading document!",
                                        error
                                      )
                                    }
                                  >
                                    <Page pageNumber={pageNumber} />
                                  </Document>
                                ) : (
                                  <img src={item?.url} alt="" />
                                )}
                              </div>
                              <div className="flex justify-between mt-5 pb-3">
                                <p className="">
                                  Page {pageNumber || (numPages ? 1 : "--")} of{" "}
                                  {numPages || "--"}
                                </p>
                                <div className="flex gap-2">
                                  <Button
                                    size="small"
                                    variant="contained"
                                    disabled={pageNumber <= 1}
                                    onClick={previousPage}
                                    sx={{ backgroundColor: "#040D43" }}
                                  >
                                    Previous
                                  </Button>
                                  <Button
                                    size="small"
                                    className="ml-2"
                                    variant="contained"
                                    disabled={pageNumber >= numPages}
                                    onClick={nextPage}
                                    sx={{ backgroundColor: "#040D43" }}
                                  >
                                    Next
                                  </Button>
                                </div>
                              </div>
                            </Card>
                          </>
                        );
                      })
                    : ""}

                  {opSourcingDetails?.Supplier_attachments?.length > 0 &&
                    opSourcingDetails?.Supplier_attachments?.map(
                      (item, index) => {
                        return (
                          <>
                            <Card
                              sx={{
                                width: ["100%", "100%", "90%", "80%"],
                                bgcolor: "background.paper",
                                boxShadow: 24,
                                borderRadius: 2,
                                maxHeight: 300,
                                overflow: "auto",
                                backgroundColor: "#FEFEFE",
                              }}
                            >
                              <div className="flex justify-between m-2 mb-2">
                                <h5 className="text-center mt-2">
                                  {" "}
                                  {item?.type} Document
                                </h5>
                                <div className="flex justify-center">
                                  <h5 className="flex justify-between  text-teal-700 mt-2 ">
                                    <Button
                                    // onClick={() =>
                                    //   downloadPDF(
                                    //     item?.url,
                                    //     `${new Date().toLocaleDateString()}_${
                                    //       item?.type
                                    //     }`
                                    //   )
                                    // }
                                    >
                                      <FileDownloadIcon
                                        icon="subway:download-1"
                                        width="24"
                                        height="24"
                                        className="ms-3"
                                        role="button"
                                      />
                                      <a
                                        style={{
                                          textDecoration: "none",
                                          color: "inherit",
                                        }}
                                        href={item?.url}
                                      >
                                        Download
                                      </a>
                                    </Button>
                                  </h5>
                                </div>
                                <Button
                                  onClick={() => handleModalOpen(item?.url)}
                                >
                                  {" "}
                                  View
                                </Button>
                              </div>

                              <div className=" flex justify-center border-2 mt-4 pb-5 border-b-teal-900  p-3">
                                {item?.url?.includes(".pdf") ? (
                                  <Document
                                    maxHeight={200}
                                    file={item?.url}
                                    onLoadSuccess={onDocumentLoadSuccess}
                                    onLoadError={(error) =>
                                      console.error(
                                        "Error while loading document!",
                                        error
                                      )
                                    }
                                  >
                                    <Page pageNumber={pageNumber} />
                                  </Document>
                                ) : (
                                  <img src={item?.url} alt="" />
                                )}
                              </div>
                              <div className="flex justify-between mt-5 pb-3">
                                <p className="">
                                  Page {pageNumber || (numPages ? 1 : "--")} of{" "}
                                  {numPages || "--"}
                                </p>
                                <div className="flex gap-2">
                                  <Button
                                    size="small"
                                    variant="contained"
                                    disabled={pageNumber <= 1}
                                    onClick={previousPage}
                                    sx={{ backgroundColor: "#040D43" }}
                                  >
                                    Previous
                                  </Button>
                                  <Button
                                    size="small"
                                    className="ml-2"
                                    variant="contained"
                                    disabled={pageNumber >= numPages}
                                    onClick={nextPage}
                                    sx={{ backgroundColor: "#040D43" }}
                                  >
                                    Next
                                  </Button>
                                </div>
                              </div>
                            </Card>
                          </>
                        );
                      }
                    )}
                </div>
                {isEmptyObject(opSourcingDetails) && (
                  <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-3 mt-2 ">
                    <div>
                      <label
                        for="branch"
                        className="block mb-2 text-sm font-medium text-blue-900 dark:text-white flex justify-start ms-1"
                      >
                        Add Documents
                      </label>
                      <Button
                        sx={{ backgroundColor: "gray" }}
                        variant="contained"
                        onClick={() => handleOpen()}
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        disabled={isPending}
                      >
                        <CloudUploadIcon />
                        <b className="ms-2 mt-1">Upload Documents</b>
                      </Button>
                    </div>
                  </div>
                )}

                {/* {isEmptyObject(opSourcingDetails) && (
                  <div className="flex justify-end mt-2 gap-2">
                    <Button
                      color="error"
                      variant="contained"
                      size="small"
                      onClick={(e) => formik.resetForm()}
                      disabled={isPending}
                    >
                      CLEAR
                    </Button>
                  </div>
                )} */}
                <div className="flex justify-end mt-2 gap-2">
                  <Button
                    variant="contained"
                    size="small"
                    type="submit"
                    sx={{ backgroundColor: "#0D9223" }}
                    disabled={isPending}
                  >
                    SAVE
                  </Button>
                </div>
                {/* <div className="flex justify-end mt-2 gap-2">
                  <Button
                    color="error"
                    variant="contained"
                    size="small"
                    onClick={(e) => formik.resetForm()}
                  >
                    CLEAR
                  </Button>
                  <Button
                    variant="contained"
                    size="small"
                    type="submit"
                    sx={{ backgroundColor: "#0D9223" }}
                  >
                    SAVE
                  </Button>
                </div> */}
              </form>
              {/* <form onSubmit={formik.handleSubmit}>
                {isEmptyObject(opSourcingDetails) && (
                  <div className="row mt-3 ">
                    <div className="col col-md-6 col-lg-6 col-sm-6">
                      <Button
                        variant="contained"
                        onClick={handleModalOpenSupplier}
                      >
                        + Add Existing Supplier
                      </Button>
                    </div>
                    <div className="col col-md-6 col-lg-6 col-sm-6">
                      <Button
                        variant="contained"
                        onClick={handleModalOpenInventory}
                      >
                        + Add From Inventory
                      </Button>
                    </div>
                  </div>
                )}
                <div className="grid grid-cols-2 gap-4">
                  <div className="mb-3">
                    <label
                      for="supplier_name"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Supplier Name
                    </label>
                    <input
                      type="text"
                      id="supplier_name"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="supplier_name"
                      value={formik.values.supplier_name}
                      disabled
                    />
                    {formik.errors.supplier_name ? (
                      <div className="text-red-600 text-sm">
                        {formik.errors.supplier_name}
                      </div>
                    ) : null}
                  </div>
                  <div className="mb-3">
                    <label
                      for="supplier_firm_name"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Supplier Firm Name
                    </label>
                    <input
                      type="text"
                      id="supplier_firm_name"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="supplier_firm_name"
                      value={formik.values.supplier_firm_name}
                      disabled
                    />
                    {formik.errors.supplier_firm_name ? (
                      <div className="text-red-600 text-sm">
                        {formik.errors.supplier_firm_name}
                      </div>
                    ) : null}
                  </div>

                  <div className="mb-3">
                    <label
                      for="po_date"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      PO Date
                    </label>
                    <input
                      type="date"
                      id="po_date"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="po_date"
                      onChange={formik.handleChange}
                      value={formik.values.po_date}
                      disabled={formDisable}
                    />
                    {formik.errors.po_date ? (
                      <div className="text-red-600 text-sm">
                        {formik.errors.po_date}
                      </div>
                    ) : null}
                  </div>
                  <div className="mb-3">
                    <label
                      for="po_number"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      PO Number
                    </label>
                    <input
                      type="text"
                      id="po_number"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="po_number"
                      placeholder="Enter PO Number"
                      onChange={formik.handleChange}
                      value={formik.values.po_number}
                      disabled={formDisable}
                    />
                    {formik.errors.po_number ? (
                      <div className="text-red-600 text-sm">
                        {formik.errors.po_number}
                      </div>
                    ) : null}
                  </div>
                  <div className="mb-3">
                    <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                      Field Executive
                    </label>
                    <select
                      value={formik.values.field_executive}
                      onChange={formik.handleChange}
                      disabled={formDisable}
                      name="field_executive"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    >
                      <option value="Select Expense">Select Option</option>
                      {rmDetails.map((each, index) => (
                        <option value={each?.rm_name} key={index}>
                          {each?.rm_name}
                        </option>
                      ))}
                    </select>
                    {formik.errors.field_executive ? (
                      <div className="text-red-600 text-sm">
                        {formik?.errors?.field_executive}
                      </div>
                    ) : null}
                  </div>
                  <div className="mb-3">
                    <label
                      for="quantity"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Quantity
                    </label>
                    <input
                      type="number" onWheel={(e) => e.target.blur()}
                      id="quantity"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="quantity"
                      placeholder="Enter Quantity"
                      onChange={formik.handleChange}
                      value={formik.values.quantity}
                      disabled={formDisable}
                    />
                    {formik.errors.quantity ? (
                      <div className="text-red-600 text-sm">
                        {formik.errors.quantity}
                      </div>
                    ) : null}
                  </div>
                  <div className="mb-3">
                    <label
                      for="gst"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      GST(Amount)
                    </label>
                    <input
                      type="number" onWheel={(e) => e.target.blur()}
                      id="gst"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="gst"
                      placeholder="Enter GST (Rs)"
                      onChange={formik.handleChange}
                      value={formik.values.gst || "NA"}
                      disabled={formDisable}
                    />
                    
                  </div>
                  <div className="mb-3">
                    <label
                      for="cgst"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      CGST
                    </label>
                    <input
                      type="number" onWheel={(e) => e.target.blur()}
                      id="cgst"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="cgst"
                      onChange={formik.handleChange}
                      value={formik.values.cgst || "NA"}
                      disabled
                    />
                  </div>
                  <div className="mb-3">
                    <label
                      for="sgst"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      SGST
                    </label>
                    <input
                      type="number" onWheel={(e) => e.target.blur()}
                      id="sgst"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="sgst"
                      value={formik.values.sgst}
                      disabled
                    />
                  </div>
                  <div className="mb-3">
                    <label
                      for="igst"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      IGST
                    </label>
                    <input
                      type="number" onWheel={(e) => e.target.blur()}
                      id="igst"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="igst"
                      value={formik.values.igst}
                      disabled
                    />
                  </div>
                  <div className="mb-3">
                    <label
                      for="unit_price"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Unit Price
                    </label>
                    <input
                      type="number" onWheel={(e) => e.target.blur()}
                      id="unit_price"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="unit_price"
                      placeholder="Enter Unit Price (Rs)"
                      onChange={formik.handleChange}
                      value={formik.values.unit_price || "NA"}
                      disabled={formDisable}
                    />
                    {formik.errors.unit_price ? (
                      <div className="text-red-600 text-sm">
                        {formik.errors.unit_price}
                      </div>
                    ) : null}
                  </div>
                  <div className="mb-3">
                    <label
                      for="total_amount"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Total Amount(Total CP)
                    </label>
                    <input
                      type="number" onWheel={(e) => e.target.blur()}
                      id="total_amount"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="total_amount"
                      value={formik.values.total_amount || "NA"}
                      disabled
                    />
                    {formik.errors.total_amount ? (
                      <div className="text-red-600 text-sm">
                        {formik.errors.total_amount}
                      </div>
                    ) : null}
                  </div>
                  <div className="mb-3">
                    <label
                      for="address_line_1"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Address Line 1
                    </label>
                    <input
                      type="text"
                      id="address_line_1"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="address_line_1"
                      value={formik.values.address_line_1 || "NA"}
                      disabled
                    />
                    {formik.errors.address_line_1 ? (
                      <div className="text-red-600 text-sm">
                        {formik.errors.address_line_1}
                      </div>
                    ) : null}
                  </div>
                  <div className="mb-3">
                    <label
                      for="address_line_2"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Address Line 2
                    </label>
                    <input
                      type="text"
                      id="address_line_2"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="address_line_2"
                      value={formik.values.address_line_2 || "NA"}
                      disabled
                    />
                    {formik.errors.address_line_2 ? (
                      <div className="text-red-600 text-sm">
                        {formik.errors.address_line_2}
                      </div>
                    ) : null}
                  </div>
                  <div className="mb-3">
                    <label
                      for="city_state"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      City/State
                    </label>
                    <input
                      type="text"
                      id="city_state"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="city_state"
                      value={formik.values.city_state || "NA"}
                      disabled
                    />
                    {formik.errors.city_state ? (
                      <div className="text-red-600 text-sm">
                        {formik.errors.city_state}
                      </div>
                    ) : null}
                  </div>
                  <div className="mb-3">
                    <label
                      for="pin_code"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Pin Code
                    </label>
                    <input
                      type="text"
                      id="pin_code"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="pin_code"
                      value={formik.values.pin_code || "NA"}
                      disabled
                    />
                    {formik.errors.pin_code ? (
                      <div className="text-red-600 text-sm">
                        {formik.errors.pin_code}
                      </div>
                    ) : null}
                  </div>
                  <div className="mb-3">
                    <label
                      for="gst_number"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      GST Number
                    </label>
                    <input
                      type="text"
                      id="gst_number"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="gst_number"
                      value={formik.values.gst_number || "NA"}
                      disabled
                    />
                    {formik.errors.gst_number ? (
                      <div className="text-red-600 text-sm">
                        {formik.errors.gst_number}
                      </div>
                    ) : null}
                  </div>
                  <div className="mb-3">
                    <label
                      for="pan"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      PAN
                    </label>
                    <input
                      type="text"
                      id="pan"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="pan"
                      value={formik.values.pan || "NA"}
                      disabled
                    />
                    {formik.errors.pan ? (
                      <div className="text-red-600 text-sm">
                        {formik.errors.pan}
                      </div>
                    ) : null}
                  </div>
                  <div className="mb-3">
                    <label
                      for="contact_no"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Contact No
                    </label>
                    <input
                      type="text"
                      id="contact_no"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="contact_no"
                      value={formik.values.contact_no || "NA"}
                      disabled
                    />
                    {formik.errors.contact_no ? (
                      <div className="text-red-600 text-sm">
                        {formik.errors.contact_no}
                      </div>
                    ) : null}
                  </div>
                  <div className="mb-3">
                    <label
                      for="bank_ac_no"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Bank Ac No
                    </label>
                    <input
                      type="text"
                      id="bank_ac_no"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="bank_ac_no"
                      value={formik.values.bank_ac_no || "NA"}
                      disabled
                    />
                    {formik.errors.bank_ac_no ? (
                      <div className="text-red-600 text-sm">
                        {formik.errors.bank_ac_no}
                      </div>
                    ) : null}
                  </div>
                  <div className="mb-3">
                    <label
                      for="branch"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Branch
                    </label>
                    <input
                      type="text"
                      id="branch"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="branch"
                      value={formik.values.branch || "NA"}
                      disabled
                    />
                    {formik.errors.branch ? (
                      <div className="text-red-600 text-sm">
                        {formik.errors.branch}
                      </div>
                    ) : null}
                  </div>
                  <div className="mb-3">
                    <label
                      for="ifsc_code"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      IFSC Code
                    </label>
                    <input
                      type="text"
                      id="ifsc_code"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="ifsc_code"
                      value={formik.values.ifsc_code || "NA"}
                      disabled
                    />
                    {formik.errors.ifsc_code ? (
                      <div className="text-red-600 text-sm">
                        {formik.errors.ifsc_code}
                      </div>
                    ) : null}
                  </div>
                </div>

                {isEmptyObject(opSourcingDetails) && (
                  <div className="flex justify-end mt-2">
                    <Button color="error" onClick={(e) => formik.resetForm()}>
                      CLEAR
                    </Button>
                    <Button type="submit">SAVE</Button>
                  </div>
                )}
              </form> */}
            </div>
          )}
        </div>
      </div>
      <UploadDocs
        open={open}
        handleClose={handleClose}
        handleAddObject={handleAddObject}
      />

      <Modal
        open={activeModal}
        onClose={handleModalClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            width: "50%",
            height: "80%",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            overflowY: "auto",
          }}
        >
          <div className="">
            <IconButton
              aria-label="close"
              style={{ position: "absolute", right: "8px", top: "8px" }}
              onClick={() => handleModalClose()}
            >
              <CloseIcon />
            </IconButton>
          </div>
          <div className="flex flex-col items-center justify-center space-y-5 h-full">
            {pdfUrl?.toLowerCase().endsWith(".pdf") ? (
              <ShowPDF pdfUrl={pdfUrl} />
            ) : (
              <img src={pdfUrl} alt="uploaded image" />
            )}
          </div>
        </Box>
      </Modal>
    </>
  );
}

export default SupplierDetailsForm;
